import React, { useEffect, useState, useContext } from "react";

import LoadingContext from "../../context/Loading/Loading";
import UserContext from "../../context/User/User";
import FlexPackDetailsContext from "../../context/FlexPackDetails/FlexPackDetails";

import AuthService from "../../utilities/services/auth.service";

import useSafeAsync from "../../utilities/useSafeAsync";

import { ORGANIZATION_PERMISSION_SLUGS } from "@blocktickets/shared-utils";
import { checkPermission } from "../../utilities/helpers";
import { getFlexPack, updateFlexPackVisibility } from "../../utilities/api";

import { Cards } from "./Cards";
import { NoPermissionsContainer } from "../NoPermissionsContainer";
import { PageLoadingContainer } from "../PageLoadingContainer";

export default function FlexPackDashboardWrapper({ flexPackId }) {
  const safeSetState = useSafeAsync();

  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext);

  const { orgPermissions } = useContext(UserContext);

  const { getPermissions } = AuthService;

  const {
    updateFlexPack,
    hasFlexPackEnded,
    updateHasFlexPackEnded,
    updateIsFlexPackOnsale,
    updateIsFlexPackSoldout,
    updateIsFlexPackPublished,
  } = useContext(FlexPackDetailsContext);

  const orgPermissionsReady = orgPermissions?.length > 0;
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(
      getPermissions(),
      ORGANIZATION_PERMISSION_SLUGS.FLEX_PACKAGES_MANAGEMENT,
    );

  const [flexPack, setFlexPack] = useState();

  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!orgPermissionsReady) return;
    if (!hasPermission) {
      hideLoading();
      return;
    }

    showLoading();
    loadFlexPack();
  }, [orgPermissionsReady, hasPermission, flexPackId]);

  const loadFlexPack = async () => {
    try {
      const flexPackData = await getFlexPack(flexPackId);

      safeSetState(() => {
        setFlexPack(flexPackData?.data[0]);
        setIsVisible(flexPackData.data[0]?.isVisible);
        // context updates
        updateIsFlexPackOnsale(flexPackData?.data[0]);
        updateHasFlexPackEnded(flexPackData?.data[0]);
        updateIsFlexPackSoldout(flexPackData?.data[0]);
        updateIsFlexPackPublished(flexPackData?.data[0]);
      });
    } catch (err) {
      console.error(err);
    } finally {
      hideLoading();
    }
  };

  const handleChange = (_, isVisible) => {
    setIsVisible(isVisible);
    // update context with changed isVisible
    updateFlexPack({ ...flexPack, isVisible });
    // update isVisible in db
    updateFlexPackVisibility({
      data: {
        id: flexPack?.uuid,
        isVisible,
      },
    });
  };

  if (!orgPermissionsReady) {
    return <PageLoadingContainer />;
  }

  if (!hasPermission) {
    return <NoPermissionsContainer />;
  }

  if (isLoading) {
    return <PageLoadingContainer />;
  }

  return (
    <>
      <div className="position-relative">
        <div
          className="max-width-wrapper"
          data-testid="flex-pack-dashboard-wrapper-section"
        >
          <header className="section-header section-heading">
            <h1>Dashboard</h1>
          </header>
          <Cards
            flexPack={flexPack}
            isDisabled={hasFlexPackEnded}
            isVisible={isVisible}
            handleChange={handleChange}
          />
        </div>
      </div>
    </>
  );
}
